import React, { useState, useRef, useMemo, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'
import { useLoadProgress } from '../hooks/useLoadProgress'
import logo from '../images/原住民族委員會.png'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    login: true,
    // login: false,
    title: '網路問卷通行碼（調查表正面右上角）',
    placeholder: '1 碼英文+5 碼數字，如：Z12345',
    alert: '通行碼有誤，請重新登入，或洽客服詢問 02-23315133 #601~604 羅小姐',
    useUserIdLogin: true,
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  const canShowPrevButtonPages = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
  // const canShowPrevButtonPages = null
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  const bringOptionsMapRef = useRef({})
  // 暫存需加
  const [isReady, setIsReady] = useState(false)
  const userIdRef = useRef(null)
  // 防止閃閃
  useEffect(() => {
    const timeout = setTimeout(() => {
      const isMobile = window.innerWidth <= 576
      if (!isMobile) return

      const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const rootEl = document.querySelector('.sd-root-modern')
            if (
              rootEl &&
              !rootEl.classList.contains('sd-root-modern--mobile')
            ) {
              rootEl.classList.add('sd-root-modern--mobile')
              console.log('✅ 強制加上 mobile class 避免抖動')
            }
          }
        }
      })

      observer.observe(document.getElementById('root'), {
        childList: true,
        subtree: true,
      })

      // 清除
      return () => observer.disconnect()
    }, 100) // 100ms 後再判斷

    return () => clearTimeout(timeout)
  }, [])
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(30)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  const agreeSurvey = useMemo(() => {
    if (myAgreeJson) {
      myAgreeJson.logo = logo
    }
    return new Model(myAgreeJson)
  }, [myAgreeJson])

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  const visibleIfConditionsInit = {
    q9: '{q8} = 0',
    q10: '{q8} = 2',

    q16: '{q15} = 2',

    q19: '{q18} anyof [0, 1, 2, 3, 4, 5, "other"]',
    q20: '{q18} anyof [0, 1, 2, 3, 4, 5, "other"]',
    q21: '({q18} anyof [0, 1, 2, 3, 4, 5, "other"]) and {q20} = 0',

    q29: '{q28} = 0',
    q30: '{q28} = 0',
    q31: '{q28} = 0',
    q32: '{q28} = 0',
    q33: '{q28} = 0',
    q34: '{q28} = 0',

    q39: '{q38} = 0',

    q47: '{q46} = 0',
    q48: '{q46} = 0',
    q49: '{q46} = 0',
    q50: '{q46} = 0',
    q51: '{q46} = 0',

    q62: '{q61} = 1',
    q64: '{q63} = 1',
    q66: '{q65} = 1',
    q68: '{q67} = 1',
    q70: '{q69} = 1',

    q73: '{q72} = 2',
    q74: '{q72} = 3',
    q76: '{q75} = 2',
    q77: '{q75} = 3',
    q79: '{q78} = 2',
    q80: '{q78} = 3',

    q82: '{q81} = 2',
    q83: '{q81} = 3',
    q84: '{q81} = 0 or {q81} = 1',
    q85: '({q81} = 0 or {q81} = 1) and ({q84} anyof [4])',
    q86: '({q81} = 0 or {q81} = 1) and ({q84} anyof [13])',
    q87: '({q81} = 0 or {q81} = 1) and ({q84} anyof [21])',

    q89: '{q88} = 0',
    q90: '{q88} = 1',
    q91: '{q88} = 2',
    q92: '{q88} = 3',
    q93: '{q88} = 0 or {q88} = 1',

    q95: '{q94} = 0',
    q96: '({q94} = 0) and ({q95} anyof [0, 1, 2])',
    q97: '({q94} = 0) and ({q95} anyof [0, 1, 2])',

    q98: '({q94} = 0) and ({q95} anyof [0, 1, 2]) and ({q97} = 0)',
    q99: '({q94} = 0) and ({q95} anyof [0, 1, 2]) and ({q97} = 0) and ({q98} anyof [1])',
    q100: '({q94} = 0) and ({q95} anyof [0, 1, 2]) and ({q97} = 0) and ({q98} anyof [3])',

    q103: '{q102} = 2',
    q104: '({q102} = 2) and ({q103} anyof [1])',
    q105: '({q102} = 2) and ({q103} anyof [3])',

    q108: '{q107} = 0',
    q109: '({q107} = 0) and ({q108} anyof [0])',
    q110: '({q107} = 0) and ({q108} anyof [1])',
    q111: '({q107} = 0) and ({q108} anyof ["other"])',

    q113: '{q112} anyof [0, 1, 2, 3, 4, 5, "other"]',
    q115: '{q114} = 2',

    q123: '{q122} = 0',
    q124: '({q122} = 0) and ({q123} anyof [10])',
    q125: '({q122} = 0) and ({q123} anyof [21])',
    q126: '({q122} = 0) and ({q123} anyof [22])',

    q127: '{q122} = 0',
    q128: '{q122} = 0',
    q129: '{q122} = 0',
    q130: '({q122} = 0) and ({q129} anyof [13])',

    q132: '{q131} = 1',
    q133: '({q131} = 0 or {q131} = 1 or {q131} = 2) and ({q132} anyof [10])',
    q134: '({q131} = 0 or {q131} = 1 or {q131} = 2) and ({q132} anyof [21])',
    q135: '({q131} = 0 or {q131} = 1 or {q131} = 2) and ({q132} anyof [22])',
    q136: '{q131} = 0 or {q131} = 1 or {q131} = 2',
    q138: '{q137} anyof [19]',

    q142: '{q141} = 2 or {q141} = 3',

    q148: '{q147} = 1',
    q149: '{q147} = 1',
    q150: '{q147} = 1',
    q151: '{q147} = 1',
  }
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [100]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  const triggersConditionsInit = [
    // {
    //   type: 'complete',
    //   expression: `({q1} = 0 or {q1} = 7) or ({q3} anyof [0, 1, 2] ) or ({q4} notcontains [3] ) or ({q5} anyof ["none"]) or ({q6} = 3)`,
    // },
  ]
  // const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null
  // 帶出: 帶入
  const questionMappings = {
    // q20: 'q21',
  }

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    questionMappings,
    bringOptionsMapRef,
    // 暫存需加
    userIdRef,
    choiceIndexMapRef,
  })

  // const newSurvey = new Model(convertedSurvey)

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    convertedSurvey.pageNextText = '暫存並繼續'
    convertedSurvey.logo = logo
    return new Model(convertedSurvey)
  }, [convertedSurvey])

  // 暫存需加
  const otherAnswersRef = useRef({})
  const noneAnswersRef = useRef({})
  const matrixAnswersRef = useRef({})
  const timestampsRef = useRef({})

  // 暫存需加
  useLoadProgress({
    surveyModel: surveyModel, // 若 myAgreeJson 為 null，agreeSurvey 亦為 null
    convertedSurvey: myAgreeJson,
    isReady,
    requiresLogin,
    setIsLoading,
    pid,
    ac,
    tk,
    choiceIndexMapRef,
    choicesOrderRef,
    bringOptionsMapRef,
    otherAnswers: otherAnswersRef.current,
    noneAnswers: noneAnswersRef.current,
    matrixAnswers: matrixAnswersRef.current,
    timestamps: timestampsRef.current,
  })

  // 暫存需加
  // SurveyModel 初始化完成 → 標記可互動
  useEffect(() => {
    if (agreeSurvey) {
      const id = setTimeout(() => setIsReady(true), 50)
      return () => clearTimeout(id)
    }
  }, [agreeSurvey])

  // 設置 survey 準備就緒狀態
  useEffect(() => {
    if (surveyModel) {
      // 給 survey 一些時間完成初始化
      setTimeout(() => {
        setIsReady(true)
      }, 50)
    }
  }, [surveyModel])

  // 當 surveyModel 建立時，自動捲動到頂端
  useEffect(() => {
    if (surveyModel) {
      // 延遲執行以確保 DOM 已更新
      setTimeout(() => {
        // 捲動到頁面頂端
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'instant', // 平滑捲動，也可以使用 'instant' 立即跳到頂端
        })

        // 或者也可以嘗試捲動問卷容器本身
        const surveyContainer = document.querySelector('.sd-root-modern')
        if (surveyContainer) {
          surveyContainer.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 100) // 給 DOM 一點時間完成渲染
    }
  }, [surveyModel])

  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  const endMessage = `目前與您相同特性的樣本額滿，已停止收卷，可惜沒辦法繼續參與本次活動。如果覺得這個主題很有意思，非常歡迎您分享本問卷連結給親友，或是加入我們的<a href='https://lin.ee/HWETcqy'>LINE@</a>，隨時得到最新填問卷獲好禮的消息。<p>請按「完成」前往下載 EZChoice 或填寫更多問卷</p>`

  function helpFunction(survey, options) {
    console.log('AA', survey.getValue('q3'))
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  // expression: `({q1} = 0 or {q1} = 7) or ({q3} anyof [0, 1, 2] ) or ({q4} notcontains [3] ) or ({q5} anyof ["none"]) or ({q6} = 3)`,

  const endSurveyMsg = (survey) => {
    // if (
    //   survey.getValue('q1') === 0 ||
    //   survey.getValue('q1') === 7 ||
    //   survey.getValue('q3').some((v) => v === 0 || v === 1 || v === 2) ||
    //   !survey.getValue('q4').includes(3) ||
    //   survey.getValue('q5')[0] === 'none' ||
    //   survey.getValue('q6') === 3
    // ) {
    //   setCompletionMessage(endMessage)
    // } else {
    setCompletionMessage(
      `<div>感謝您/貴公司協助填答，您的資料僅供原住民族委員會經濟產業發展輔導或協助使用不做他途，若您對調查有任何問題，請聯絡：<br><br>1.典通股份有限公司 羅小姐 02-23315133 #601-604<br>2.原住民族委員會 免付費金融服務專線 0800-508-818<br>(若企業有金融輔導需求，亦可連絡原民會金輔員)<br><br>成功問卷電子禮券最遲將於115年4月1日發出，再次感謝您/貴公司撥冗回卷。</div>`
    )
    // }
  }

  // useEffect(() => {
  //   console.log('bringOptionsMapRef', bringOptionsMapRef)
  // }, [bringOptionsMapRef])

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    endSurveyMsg,
    bringOptionsMapRef,
    // 暫存需加
    requiresLogin,
    userIdRef, // 傳入 ref 而不是直接傳 userId
    enableProgressSaving: requiresLogin.login, // 根據登入需求啟用
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
